import { render, staticRenderFns } from "./Process-4.vue?vue&type=template&id=d2821b2e&scoped=true&"
import script from "./Process-4.vue?vue&type=script&lang=js&"
export * from "./Process-4.vue?vue&type=script&lang=js&"
import style0 from "./Process-4.vue?vue&type=style&index=0&id=d2821b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2821b2e",
  null
  
)

export default component.exports